import { defineMessages } from 'react-intl';

export default defineMessages({
    bankAccount: {
        id: '_.your_company.bank_account_card.bank_account',
        defaultMessage: 'Your bank account'
    },
    bankAccountNumber: {
        id: '_.your_company.bank_account_card.bank_account_number',
        defaultMessage: 'Account number:'
    },
    sortCode: {
        id: '_.your_company.bank_account_card.sort_code',
        defaultMessage: 'Sort code:'
    },
    IBANNumber: {
        id: '_.your_company.bank_account_card.iban',
        defaultMessage: 'IBAN:'
    },
    bankAccountInfoText: {
        id: '_.your_company.bank_account_card.bank_account_info_text',
        defaultMessage: 'We’ll be sending your funds to:'
    }
});
